import { getCaregiverPointSourceLabel } from '@apps/web/lib/caregiver_points';
import { formatDateAndTime } from '@apps/web/lib/date_utils';
import { type CaregiverPointEntryRead } from '@libraries/typescript/api_client';

type PointEntryCardProps = {
    readonly entry: CaregiverPointEntryRead;
    readonly timezone: string;
};

export function PointEntryCard({ entry, timezone }: PointEntryCardProps) {
    return (
        <div className="rounded-md border p-3 text-sm">
            <div className="flex items-center justify-between gap-3">
                <div className="text-foreground font-medium">
                    {getCaregiverPointSourceLabel(entry.source_type)}
                </div>
                <div
                    className={
                        entry.points >= 0
                            ? 'font-semibold text-green-700 dark:text-green-400'
                            : 'font-semibold text-red-700 dark:text-red-400'
                    }
                >
                    {entry.points > 0 ? '+' : ''}
                    {entry.points}
                </div>
            </div>
            <div className="text-muted-foreground mt-1">
                {formatDateAndTime(entry.created_at, timezone)}
            </div>
            {entry.reason ? (
                <div className="text-foreground/80 mt-2">{entry.reason}</div>
            ) : null}
        </div>
    );
}
